export const BLUE = "#4A90E2";
export const WHITE_COLOR = "#FFFFFF";
export const BLACK_COLOR = "#000000";
export const GRAY_HIGHLIGHT = "#9B9B9B";
export const GRAY_MEDIUM = "#7A7A7A";
export const GRAY_BG = "#F4F5F7";
export const CREDIT_GREEN = "#38AA8D";
export const DASHLET_GREEN = "#008751";
export const DEBIT_RED = "#E93F33";
export const TEXT_BG_GRAY = "#B7B7B7";
